import { StrictMode, useEffect } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { clearLegacyWalletData } from '@/hooks/useWallet'
import { initMetaPixel, storeUTMParams } from '@/lib/metaPixel'
import { injectCustomHeadCode } from '@/lib/customHeadCode'

// Clear legacy wallet data on app start to prevent cross-user contamination
clearLegacyWalletData();


// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('[SW] Registered:', registration.scope);
      })
      .catch(error => {
        console.log('[SW] Registration failed:', error);
      });
  });
}

// App wrapper with Meta Pixel tracking
function AppWithTracking() {
  useEffect(() => {
    // Initialize Meta Pixel for ad tracking
    initMetaPixel()
    // Store UTM params for campaign attribution
    storeUTMParams()
    // Inject custom head code (admin se set kiya hua)
    injectCustomHeadCode()
    
    // Log pixel status for debugging
    const pixelId = localStorage.getItem('meta_pixel_id')
    const enabled = localStorage.getItem('meta_pixel_enabled') === 'true'
    console.log('[Meta Pixel] Status:', enabled ? 'ENABLED' : 'DISABLED', '| ID:', pixelId || 'NOT SET')
  }, [])

  return <App />
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppWithTracking />
  </StrictMode>,
)
